import React from 'react';
import Header from "../components/Header";
import Photo from '../assets/atendimento.jpg';
import { Box, Typography, Grid, Container } from '@mui/material';
import { createGlobalStyle } from 'styled-components';
import WhatsAppContact from '../components/Contato';
import Footer from '../components/Footer';
import allianz from '../assets/allianz-logo.svg'
import  alliro from '../assets/alliro.png'
import azul from '../assets/azul.png'
import bradesco from "../assets/bradesco-seguros-logo-0-1.png"
import Ezze from '../assets/Ezze.png'
import HDI from '../assets/HDI.png'
import Itau from '../assets/itau-seguros-logo-17F11A539B-seeklogo.com.png'
import Ituran from '../assets/Ituran.png'
import Loovi from '../assets/loovi.png'
import Map from '../assets/Mapfre_logo.png'
import Mtsui from '../assets/mtsui.png'
import Porto from '../assets/porto-seguro.png'
import Suhai from '../assets/suhai-seguradora-logo-1.png'
import Tokio from '../assets/tokio-marine-seguradora-512.png'
import Yelum from '../assets/Yelum.png'
import Youse from '../assets/youse.png'
import Zurich from '../assets/zurich.png'


// Estilos globais
const GlobalStyle = createGlobalStyle`
  body, html {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    overflow-x: hidden;
  }
`;

function Contact() {
  // Dados de cada contato
  const contacts = [
    { id: 1, title: "Alliro Seguros", imageSrc: alliro, phoneNumber: '08007701318' },
    { id: 2, title: "Allianz", imageSrc: allianz, phoneNumber: ' 08000130700' },
    { id: 3, title: "Azul seguros", imageSrc: azul, phoneNumber: '40043700' },
    { id: 4, title: "Bradesco Seguros", imageSrc: bradesco, phoneNumber: ' 40042757 ou 08007012757' },
    { id: 5, title: "Ezze", imageSrc: Ezze, phoneNumber: '08007029985' },
    { id: 6, title: "HDI Seguros", imageSrc: HDI, phoneNumber: '30035390 ou 08004344340' },
    { id: 7, title: "Itaú Seguros", imageSrc: Itau, phoneNumber: '30034240 capitais e metropoles, ou 08007284240 demais localidades ' },
    { id: 8, title: "Ituran Seguros", imageSrc: Ituran, phoneNumber: '08000153600' },
    { id: 9, title: "Loovi Seguros", imageSrc: Loovi, phoneNumber: '08009484888' },
    { id: 10, title: "Mapfre Seguros", imageSrc: Map , phoneNumber: ' 40040101' },
    { id: 11, title: "Mitsui Sumitomo", imageSrc: Mtsui, phoneNumber: '08007077883' },
    { id: 12, title: "Porto Seguro", imageSrc: Porto, phoneNumber: '33376786' },
    { id: 13, title: "Suhai Seguros", imageSrc: Suhai, phoneNumber: '30030335' },
    { id: 14, title: "Tokio Marine", imageSrc: Tokio, phoneNumber: '08003186546' },
    { id: 15, title: "Yelum ", imageSrc: Yelum, phoneNumber: '08007014120' },
    { id: 14, title: "Youse", imageSrc: Youse, phoneNumber: '30035770 capitais e metropolitanas, ou 08007309901 demais localidades' },
    { id: 15, title: "Zurich Seguros", imageSrc: Zurich, phoneNumber: '08002854141' },
  ];

  return (
    <div
      style={{
        backgroundColor: '#f0f0f0', 
        margin: 0,
        padding: 0,
        minHeight: '100vh',
        position: 'relative',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      <GlobalStyle />
      <Header />
      
      {/* Box com imagem de fundo */}
  
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '300px',
          backgroundImage: `url(${Photo})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.79)',
          }}
        />
        <Box sx={{ position: 'relative', textAlign: 'center', color: '#4AC200' }}>
          <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
            Contato
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 'normal' }}>
            Descubra nossas redes sociais, mande uma mensagem!
          </Typography>
        </Box>
      </Box>

      <Typography
          variant="h4"
          sx={{
            color: '#4AC200',
            textAlign: 'center',
            fontWeight: 'bold',
            mb: 3,
          }}
        >
          Mande aqui sua menssagem
        </Typography>



      {/* Grid 3x5 com WhatsAppContact */}
      <Container sx={{ mt: 4 }}>
        <Typography
          variant="h4"
          sx={{
            color: '#4AC200',
            textAlign: 'center',
            fontWeight: 'bold',
            mb: 3,
          }}
        >
          Nossos Contatos
        </Typography>
        <Grid container spacing={3}
        id="grid-section">
          {contacts.map((contact) => (
            <Grid item xs={12} sm={6} md={4} key={contact.id}>
              <WhatsAppContact
              title={contact.title}
                imageSrc={contact.imageSrc}
                altText={`Contato ${contact.id}`}
                message={`Olá! Gostaria de falar com o contato ${contact.id}.`}
                phoneNumber={contact.phoneNumber}
              />
            </Grid>
          ))}
        </Grid>
      </Container>


      {/* Footer */}
      <Box sx={{ mt: 4 }}>
        <Footer />
      </Box>
    </div>
  );
}

export default Contact;
